import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DeckPage from './pages/DeckPage';
import FlashcardPage from './pages/FlashcardPage';
import QuizPage from './pages/QuizPage';
import TypingPage from './pages/TypingPage';
import ReviewPage from './pages/ReviewPage';
import CollectionPage from './pages/CollectionPage';
import './App.css';

function NavBar() {
  const loc = useLocation();
  return (
    <nav className="navbar">
      <Link to="/" className="nav-logo">
        <span className="logo-ja">語</span>
        <span className="logo-text">VocabMaster</span>
      </Link>
      <div className="nav-links">
        <Link to="/" className={loc.pathname === '/' ? 'active' : ''}>Trang chủ</Link>
      </div>
    </nav>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <NavBar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/deck/:id" element={<DeckPage />} />
            <Route path="/deck/:id/flashcard" element={<FlashcardPage />} />
            <Route path="/deck/:id/quiz" element={<QuizPage />} />
            <Route path="/deck/:id/typing" element={<TypingPage />} />
            <Route path="/deck/:id/review" element={<ReviewPage />} />
            <Route path="/collection/:id" element={<CollectionPage />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
